import { tokens } from "../theme";

export const mockDataTeam = [
  { id: 1, name: "Chukwudi Okafor", email: "chukwudi.okafor@gmail.com", age: 35, phone: "(080) 1234-5678", access: "admin" },
  { id: 2, name: "Ngozi Nwosu", email: "ngozi.nwosu@gmail.com", age: 25, phone: "(081) 2345-6789", access: "manager" },
  { id: 3, name: "Emeka Obi", email: "emeka.obi@gmail.com", age: 25, phone: "(070) 3456-7890", access: "user" },
  { id: 4, name: "Aisha Bello", email: "aisha.bello@gmail.com", age: 36, phone: "(090) 4567-8901", access: "admin" },
  { id: 5, name: "Ifeanyi Uche", email: "ifeanyi.uche@gmail.com", age: 31, phone: "(080) 5678-9012", access: "user" },
  { id: 6, name: "Chinedu Eze", email: "chinedu.eze@gmail.com", age: 50, phone: "(081) 6789-0123", access: "manager" },
  { id: 7, name: "Funke Ade", email: "funke.ade@gmail.com", age: 24, phone: "(070) 7890-1234", access: "user" },
  { id: 8, name: "Tunde Akin", email: "tunde.akin@gmail.com", age: 36, phone: "(090) 8901-2345", access: "user" },
  { id: 9, name: "Bola Ogun", email: "bola.ogun@gmail.com", age: 65, phone: "(080) 9012-3456", access: "admin" },
];
export const mockDataContacts = [
  { id: 1, name: "Chukwudi Okafor", email: "chukwudi.okafor@gmail.com", age: 55, phone: "(080) 1234-5678", address: "12 Ahmadu Bello Way, Lagos", city: "Lagos", zipCode: "100001", registrarId: 123512 },
  { id: 2, name: "Ngozi Nwosu", email: "ngozi.nwosu@gmail.com", age: 22, phone: "(081) 2345-6789", address: "45 Obafemi Awolowo Rd, Ibadan", city: "Ibadan", zipCode: "200002", registrarId: 123512 },
  { id: 3, name: "Emeka Obi", email: "emeka.obi@gmail.com", age: 45, phone: "(070) 3456-7890", address: "78 Ahmadu Bello Street, Enugu", city: "Enugu", zipCode: "400003", registrarId: 4132513 },
  { id: 4, name: "Aisha Bello", email: "aisha.bello@gmail.com", age: 26, phone: "(090) 4567-8901", address: "23 Nnamdi Azikiwe Ave, Abuja", city: "Abuja", zipCode: "900004", registrarId: 123512 },
  { id: 5, name: "Ifeanyi Uche", email: "ifeanyi.uche@gmail.com", age: 31, phone: "(080) 5678-9012", address: "67 Lagos Street, Port Harcourt", city: "Port Harcourt", zipCode: "500005", registrarId: 123512 },
  { id: 6, name: "Chinedu Eze", email: "chinedu.eze@gmail.com", age: 23, phone: "(081) 6789-0123", address: "89 Sokoto Rd, Sokoto", city: "Sokoto", zipCode: "700006", registrarId: 123512 },
  { id: 7, name: "Funke Ade", email: "funke.ade@gmail.com", age: 44, phone: "(070) 7890-1234", address: "34 Ibadan Way, Oyo", city: "Oyo", zipCode: "300007", registrarId: 123512 },
  { id: 8, name: "Tunde Akin", email: "tunde.akin@gmail.com", age: 36, phone: "(090) 8901-2345", address: "56 Kaduna Street, Kaduna", city: "Kaduna", zipCode: "600008", registrarId: 512315 },
  { id: 9, name: "Bola Ogun", email: "bola.ogun@gmail.com", age: 65, phone: "(080) 9012-3456", address: "90 Kano Avenue, Kano", city: "Kano", zipCode: "800009", registrarId: 928397 },
  { id: 10, name: "Sulaimon Muhanmmed", email: "smuhammed@gmail.com", age: 45, phone: "(080) 8015-3456", address: "9 Kogi Avenue, Kogi", city: "Lokoja", zipCode: "802029", registrarId: 928397 },
  { id: 11, name: "Atoyebi Damilare", email: "Damilareatoyebi@gmail.com", age: 74, phone: "(090) 9032-4556", address: "23 Rumen street Akoka, Lagos", city: "Lagos", zipCode: "870002", registrarId: 9754897 },
];

export const mockDataInvoices = [
  { id: 1, name: "Chukwudi Okafor", email: "chukwudi.okafor@gmail.com", cost: "21,240", phone: "(080) 1234-5678", date: "03/12/2025" },
  { id: 2, name: "Ngozi Nwosu", email: "ngozi.nwosu@gmail.com", cost: "10,240", phone: "(081) 2345-6789", date: "06/12/2025" },
  { id: 3, name: "Emeka Obi", email: "emeka.obi@gmail.com", cost: "11,240", phone: "(070) 3456-7890", date: "07/12/2025" },
  { id: 4, name: "Aisha Bello", email: "aisha.bello@gmail.com", cost: "80,550", phone: "(090) 4567-8901", date: "07/12/2025" },
  { id: 5, name: "Ifeanyi Uche", email: "ifeanyi.uche@gmail.com", cost: "4,240", phone: "(080) 5678-9012", date: "08/12/2025" },
  { id: 6, name: "Chinedu Eze", email: "chinedu.eze@gmail.com", cost: "63,120", phone: "(081) 6789-0123", date: "11/12/2025" },
  { id: 7, name: "Funke Ade", email: "funke.ade@gmail.com", cost: "52,420", phone: "(070) 7890-1234", date: "12/12/2025" },
  { id: 8, name: "Tunde Akin", email: "tunde.akin@gmail.com", cost: "21,240", phone: "(090) 8901-2345", date: "13/012/2025" },
];


export const mockTransactions = [
  { txId: "01e4dsa", user: "chukwudiokafor", date: "2025-12-31", cost: "43,950" },
  { txId: "0315dsaa", user: "ngozinwosu", date: "2025-12-31", cost: "133,450" },
  { txId: "01e4dsa", user: "emekaobi", date: "2025-12-31", cost: "43,950" },
  { txId: "51034szv", user: "aishabello", date: "2025-12-31", cost: "200,950" },
  { txId: "0a123sb", user: "ifeanyi uche", date: "2025-12-31", cost: "13,550" },
  { txId: "01e4dsa", user: "chinedueze", date: "2025-12-29", cost: "43,950" },
  { txId: "120s51a", user: "funkeade", date: "2025-12-30", cost: "24,200" },
  { txId: "0315dsaa", user: "tundeakin", date: "2025-12-30", cost: "133,450" },
];

export const mockBarData = [
  { country: "LAG", "Pizza": 137, "PizzaColor": "hsla(49, 86%, 49%, 1.00)",  "Ice Cream": 137, "Ice CreamColor": "hsl(229, 70%, 50%)","Chicken": 107, "chickenColor": "hsla(24, 83%, 35%, 1.00)", Burger: 96, BurgerColor: "hsl(296, 70%, 50%)", Rice: 72, RiceColor: "hsl(97, 70%, 50%)", Bread: 145, BreadColor: "hsl(340, 70%, 50%)" },
  { country: "ABJ", "Pizza": 137, "PizzaColor": "hsla(49, 86%, 49%, 1.00)","Ice Cream": 98, "Ice CreamColor": "hsl(307, 70%, 50%)","Chicken": 89, "chickenColor": "hsla(24, 83%, 35%, 1.00)", Burger: 88, BurgerColor: "hsl(111, 70%, 50%)", Rice: 68, RiceColor: "hsl(273, 70%, 50%)", Bread: 79, BreadColor: "hsl(275, 70%, 50%)" },
  { country: "KW", "Pizza": 137, "PizzaColor": "hsla(49, 86%, 49%, 1.00)","Ice Cream": 76, "Ice CreamColor": "hsla(0, 70%, 50%, 1.00)", "Chicken": 74, "chickenColor": "hsla(24, 83%, 35%, 1.00)",Burger: 23, BurgerColor: "hsl(96, 70%, 50%)", Rice: 34, RiceColor: "hsl(106, 70%, 50%)", Bread: 152, BreadColor: "hsl(256, 70%, 50%)" },
  { country: "KAN", "Pizza": 137, "PizzaColor": "hsla(49, 86%, 49%, 1.00)","Ice Cream": 133, "Ice CreamColor": "hsl(257, 70%, 50%)","Chicken": 65, "chickenColor": "hsla(24, 83%, 35%, 1.00)", Burger: 62, BurgerColor: "hsl(326, 70%, 50%)", Rice: 63, RiceColor: "hsl(110, 70%, 50%)", Bread: 83, BreadColor: "hsl(9, 70%, 50%)" },
  { country: "RIV", "Pizza": 137, "PizzaColor": "hsla(49, 86%, 49%, 1.00)","Ice Cream": 81, "Ice CreamColor": "hsl(190, 70%, 50%)","Chicken": 26, "chickenColor": "hsla(24, 83%, 35%, 1.00)", Burger: 60, BurgerColor: "hsl(325, 70%, 50%)", Rice: 92, RiceColor: "hsl(54, 70%, 50%)", Bread: 35, BreadColor: "hsl(285, 70%, 50%)" },
];
export const mockPieData = [
  { id: "Logistics", label: "oil", value: 239, color: "hsl(104, 70%, 50%)" },
  { id: "Agriculture", label: "agriculture", value: 170, color: "hsl(162, 70%, 50%)" },
  { id: "Tech", label: "tech", value: 322, color: "hsl(291, 70%, 50%)" },
  { id: "Services", label: "services", value: 503, color: "hsl(229, 70%, 50%)" },
  { id: "Manufacturing", label: "manufacturing", value: 584, color: "hsl(344, 70%, 50%)" },
];

export const mockLineData = [
  {
    id: "Nigeria",
    color: tokens("dark").greenAccent[300],
    data: [
      {
        x: "plane",
        y: 101,
      },
      {
        x: "helicopter",
        y: 15,
      },
      {
        x: "boat",
        y: 222,
      },
      {
        x: "train",
        y: 26,
      },
      {
        x: "subway",
        y: 0,
      },
      {
        x: "bus",
        y: 359,
      },
      {
        x: "car",
        y: 148,
      },
      {
        x: "moto",
        y: 232,
      },
      {
        x: "bicycle",
        y: 229,
      },
      {
        x: "horse",
        y: 12,
      },
      {
        x: "skateboard",
        y: 35,
      },
      {
        x: "others",
        y: 284,
      },
    ],
  },
  {
    id: "Ghana",
    color: tokens("dark").blueAccent[600],
    data: [
      {
        x: "plane",
        y: 212,
      },
      {
        x: "helicopter",
        y: 190,
      },
      {
        x: "boat",
        y: 270,
      },
      {
        x: "train",
        y: 19,
      },
      {
        x: "subway",
        y: 45,
      },
      {
        x: "bus",
        y: 195,
      },
      {
        x: "car",
        y: 88,
      },
      {
        x: "moto",
        y: 189,
      },
      {
        x: "bicycle",
        y: 121,
      },
      {
        x: "horse",
        y: 87,
      },
      {
        x: "skateboard",
        y: 299,
      },
      {
        x: "others",
        y: 251,
      },
    ],
  },
  {
    id: "USA",
    color: tokens("dark").redAccent[200],
    data: [
      {
        x: "plane",
        y: 191,
      },
      {
        x: "helicopter",
        y: 136,
      },
      {
        x: "boat",
        y: 91,
      },
      {
        x: "train",
        y: 190,
      },
      {
        x: "subway",
        y: 211,
      },
      {
        x: "bus",
        y: 152,
      },
      {
        x: "car",
        y: 189,
      },
      {
        x: "moto",
        y: 152,
      },
      {
        x: "bicycle",
        y: 8,
      },
      {
        x: "horse",
        y: 197,
      },
      {
        x: "skateboard",
        y: 107,
      },
      {
        x: "others",
        y: 170,
      },
    ],
  },
];

export const mockGeographyData = [
  {
    id: "AFG",
    value: 520600,
  },
  {
    id: "AGO",
    value: 949905,
  },
  {
    id: "ALB",
    value: 329910,
  },
  {
    id: "ARE",
    value: 675484,
  },
  {
    id: "ARG",
    value: 432239,
  },
  {
    id: "ARM",
    value: 288305,
  },
  {
    id: "ATA",
    value: 415648,
  },
  {
    id: "ATF",
    value: 665159,
  },
  {
    id: "AUT",
    value: 798526,
  },
  {
    id: "AZE",
    value: 481678,
  },
  {
    id: "BDI",
    value: 496457,
  },
  {
    id: "BEL",
    value: 252276,
  },
  {
    id: "BEN",
    value: 440315,
  },
  {
    id: "BFA",
    value: 343752,
  },
  {
    id: "BGD",
    value: 920203,
  },
  {
    id: "BGR",
    value: 261196,
  },
  {
    id: "BHS",
    value: 421551,
  },
  {
    id: "BIH",
    value: 974745,
  },
  {
    id: "BLR",
    value: 349288,
  },
  {
    id: "BLZ",
    value: 305983,
  },
  {
    id: "BOL",
    value: 430840,
  },
  {
    id: "BRN",
    value: 345666,
  },
  {
    id: "BTN",
    value: 649678,
  },
  {
    id: "BWA",
    value: 319392,
  },
  {
    id: "CAF",
    value: 722549,
  },
  {
    id: "CAN",
    value: 332843,
  },
  {
    id: "CHE",
    value: 122159,
  },
  {
    id: "CHL",
    value: 811736,
  },
  {
    id: "CHN",
    value: 593604,
  },
  {
    id: "CIV",
    value: 143219,
  },
  {
    id: "CMR",
    value: 630627,
  },
  {
    id: "COG",
    value: 498556,
  },
  {
    id: "COL",
    value: 660527,
  },
  {
    id: "CRI",
    value: 60262,
  },
  {
    id: "CUB",
    value: 177870,
  },
  {
    id: "-99",
    value: 463208,
  },
  {
    id: "CYP",
    value: 945909,
  },
  {
    id: "CZE",
    value: 500109,
  },
  {
    id: "DEU",
    value: 63345,
  },
  {
    id: "DJI",
    value: 634523,
  },
  {
    id: "DNK",
    value: 731068,
  },
  {
    id: "DOM",
    value: 262538,
  },
  {
    id: "DZA",
    value: 760695,
  },
  {
    id: "ECU",
    value: 301263,
  },
  {
    id: "EGY",
    value: 148475,
  },
  {
    id: "ERI",
    value: 939504,
  },
  {
    id: "ESP",
    value: 706050,
  },
  {
    id: "EST",
    value: 977015,
  },
  {
    id: "ETH",
    value: 461734,
  },
  {
    id: "FIN",
    value: 22800,
  },
  {
    id: "FJI",
    value: 18985,
  },
  {
    id: "FLK",
    value: 64986,
  },
  {
    id: "FRA",
    value: 447457,
  },
  {
    id: "GAB",
    value: 669675,
  },
  {
    id: "GBR",
    value: 757120,
  },
  {
    id: "GEO",
    value: 158702,
  },
  {
    id: "GHA",
    value: 893180,
  },
  {
    id: "GIN",
    value: 877288,
  },
  {
    id: "GMB",
    value: 724530,
  },
  {
    id: "GNB",
    value: 387753,
  },
  {
    id: "GNQ",
    value: 706118,
  },
  {
    id: "GRC",
    value: 377796,
  },
  {
    id: "GTM",
    value: 66890,
  },
  {
    id: "GUY",
    value: 719300,
  },
  {
    id: "HND",
    value: 739590,
  },
  {
    id: "HRV",
    value: 929467,
  },
  {
    id: "HTI",
    value: 538961,
  },
  {
    id: "HUN",
    value: 146095,
  },
  {
    id: "IDN",
    value: 490681,
  },
  {
    id: "IND",
    value: 549818,
  },
  {
    id: "IRL",
    value: 630163,
  },
  {
    id: "IRN",
    value: 596921,
  },
  {
    id: "IRQ",
    value: 767023,
  },
  {
    id: "ISL",
    value: 478682,
  },
  {
    id: "ISR",
    value: 963688,
  },
  {
    id: "ITA",
    value: 393089,
  },
  {
    id: "JAM",
    value: 83173,
  },
  {
    id: "JOR",
    value: 52005,
  },
  {
    id: "JPN",
    value: 199174,
  },
  {
    id: "KAZ",
    value: 181424,
  },
  {
    id: "KEN",
    value: 60946,
  },
  {
    id: "KGZ",
    value: 432478,
  },
  {
    id: "KHM",
    value: 254461,
  },
  {
    id: "OSA",
    value: 942447,
  },
  {
    id: "KWT",
    value: 414413,
  },
  {
    id: "LAO",
    value: 448339,
  },
  {
    id: "LBN",
    value: 620090,
  },
  {
    id: "LBR",
    value: 435950,
  },
  {
    id: "LBY",
    value: 75091,
  },
  {
    id: "LKA",
    value: 595124,
  },
  {
    id: "LSO",
    value: 483524,
  },
  {
    id: "LTU",
    value: 867357,
  },
  {
    id: "LUX",
    value: 689172,
  },
  {
    id: "LVA",
    value: 742980,
  },
  {
    id: "MAR",
    value: 236538,
  },
  {
    id: "MDA",
    value: 926836,
  },
  {
    id: "MDG",
    value: 840840,
  },
  {
    id: "MEX",
    value: 353910,
  },
  {
    id: "MKD",
    value: 505842,
  },
  {
    id: "MLI",
    value: 286082,
  },
  {
    id: "MMR",
    value: 915544,
  },
  {
    id: "MNE",
    value: 609500,
  },
  {
    id: "MNG",
    value: 410428,
  },
  {
    id: "MOZ",
    value: 32868,
  },
  {
    id: "MRT",
    value: 375671,
  },
  {
    id: "MWI",
    value: 591935,
  },
  {
    id: "MYS",
    value: 991644,
  },
  {
    id: "NAM",
    value: 701897,
  },
  {
    id: "NCL",
    value: 144098,
  },
  {
    id: "NER",
    value: 312944,
  },
  {
    id: "NGA",
    value: 862877,
  },
  {
    id: "NIC",
    value: 90831,
  },
  {
    id: "NLD",
    value: 281879,
  },
  {
    id: "NOR",
    value: 224537,
  },
  {
    id: "NPL",
    value: 322331,
  },
  {
    id: "NZL",
    value: 86615,
  },
  {
    id: "OMN",
    value: 707881,
  },
  {
    id: "PAK",
    value: 158577,
  },
  {
    id: "PAN",
    value: 738579,
  },
  {
    id: "PER",
    value: 248751,
  },
  {
    id: "PHL",
    value: 557292,
  },
  {
    id: "PNG",
    value: 516874,
  },
  {
    id: "POL",
    value: 682137,
  },
  {
    id: "PRI",
    value: 957399,
  },
  {
    id: "PRT",
    value: 846430,
  },
  {
    id: "PRY",
    value: 720555,
  },
  {
    id: "QAT",
    value: 478726,
  },
  {
    id: "ROU",
    value: 259318,
  },
  {
    id: "RUS",
    value: 268735,
  },
  {
    id: "RWA",
    value: 136781,
  },
  {
    id: "ESH",
    value: 151957,
  },
  {
    id: "SAU",
    value: 111821,
  },
  {
    id: "SDN",
    value: 927112,
  },
  {
    id: "SDS",
    value: 966473,
  },
  {
    id: "SEN",
    value: 158085,
  },
  {
    id: "SLB",
    value: 178389,
  },
  {
    id: "SLE",
    value: 528433,
  },
  {
    id: "SLV",
    value: 353467,
  },
  {
    id: "ABV",
    value: 251,
  },
  {
    id: "SOM",
    value: 445243,
  },
  {
    id: "SRB",
    value: 202402,
  },
  {
    id: "SUR",
    value: 972121,
  },
  {
    id: "SVK",
    value: 319923,
  },
  {
    id: "SVN",
    value: 728766,
  },
  {
    id: "SWZ",
    value: 379669,
  },
  {
    id: "SYR",
    value: 16221,
  },
  {
    id: "TCD",
    value: 101273,
  },
  {
    id: "TGO",
    value: 498411,
  },
  {
    id: "THA",
    value: 506906,
  },
  {
    id: "TJK",
    value: 613093,
  },
  {
    id: "TKM",
    value: 327016,
  },
  {
    id: "TLS",
    value: 607972,
  },
  {
    id: "TTO",
    value: 936365,
  },
  {
    id: "TUN",
    value: 898416,
  },
  {
    id: "TUR",
    value: 237783,
  },
  {
    id: "TWN",
    value: 878213,
  },
  {
    id: "TZA",
    value: 442174,
  },
  {
    id: "UGA",
    value: 720710,
  },
  {
    id: "UKR",
    value: 74172,
  },
  {
    id: "URY",
    value: 753177,
  },
  {
    id: "USA",
    value: 658725,
  },
  {
    id: "UZB",
    value: 550313,
  },
  {
    id: "VEN",
    value: 707492,
  },
  {
    id: "VNM",
    value: 538907,
  },
  {
    id: "VUT",
    value: 650646,
  },
  {
    id: "PSE",
    value: 476078,
  },
  {
    id: "YEM",
    value: 957751,
  },
  {
    id: "ZAF",
    value: 836949,
  },
  {
    id: "ZMB",
    value: 714503,
  },
  {
    id: "ZWE",
    value: 405217,
  },
  {
    id: "KOR",
    value: 171135,
  },
];
